export default __webpack_public_path__ + "static/media/2020-plan-3.f2395eb0.jpeg";